import React from 'react'
import { useState } from 'react'
import './forgotpassword.css'
import axios from '../../../helpers/axios'
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
    const [show, setShow] = useState(false);
    const [values, setValues] = useState({});
    const [focused, setFocused] = useState(false);
    const [userData, setUserData] = useState({});

    const navigate = useNavigate();

    const checkUser = async (e) => {
        e.preventDefault();
        const res = await axios.get(`/user/finduser/${values.nic}`);

        if (res.data.status === 200) {
            setShow(true)
            setUserData(res.data.data)
        } else {
            toast.error("Can't find user!")
        }
    }

    const handleFocus = (e) => {
        setFocused(true);
    }

    const onChangeValue = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const onSubmit = async (e) => {
        const userInfo = {
            password: values.password
        }
        const res = await axios.put(`/user/resetpassword/${userData.id}`, userInfo);

        if (res.data.response.status === 200) {
            toast.success("Password updated");
            navigate('/')
        } else {
            toast.warn(res.data.response.data);
        }
    }

    return (
        <div className='forgot-container'>
            <div>
                <h2>Reset Password</h2>
                {
                    show ? ""
                        : <div>
                            <div className='field'>
                                <input
                                    type="text"
                                    name="nic"
                                    id="nic"
                                    placeholder='Enter your NIC'
                                    value={values.nic || ''}
                                    required pattern='^(?:19|20)?\d{2}[0-9]{10}|[0-9]{9}[x|X|v|V]$'
                                    onBlur={handleFocus}
                                    focused={focused.toString()}
                                    onChange={onChangeValue}
                                />
                                <span>Invalid NIC no</span>
                            </div>
                            <div className='field'>
                                <button onClick={(e) => checkUser(e)} className='submit-btn'>Check</button>
                            </div>
                        </div>
                }
                {
                    show ?
                        <div>
                            <div className='field'>
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder='Enter your password'
                                    value={values.password || ""}
                                    onChange={onChangeValue}
                                />
                            </div>
                            <div className='field'>
                                <button onClick={(e) => onSubmit(e)} className='submit-btn'>Submit</button>
                            </div>
                        </div>
                        : ""
                }
            </div>
            <ToastContainer />
        </div>
    )
}

export default ForgotPassword